import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useList() {
  // Use toast
  const toast = useToast()

  const refListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: '#', sortable: false },
    { key: 'name', sortable: true },
    { key: 'contact_email', label: 'Email', sortable: true },
    { key: 'contact_phone',  label: 'Phone',sortable: true },
    { key: 'plan', sortable: false },
    { key: 'status', sortable: false },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalData = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('name')
  const isSortDirDesc = ref(false)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalData.value,
    }
  })

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData()
  })

  const fetchDatas = (ctx, callback) => {
    store
      .dispatch('app-org/fetchDatas', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        status: statusFilter.value,
      })
      .then(response => {
        const datas = response.data.data
        const total = response.data.total_data

        callback(datas)
        totalData.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching organization list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*


  const resolveStatusVariant = (is_approved, is_archived) => {
    if (is_archived == 1) return 'secondary'
    else if (is_approved == 2) return 'danger'
    else if (is_approved == 0) return 'info'
    else if (is_approved == 1) return 'success'
    return 'primary'
  }

  const showStatus = (is_approved, is_archived) => {
    if (is_approved == 0) return 'Pending'
    else if (is_approved == 2) return 'Rejected'
    else if (is_approved == 1){
      if (is_archived == 0) return 'Active'
      else if (is_archived == 1) return 'Archived'
    }
    return ''
  }

  return {
    fetchDatas,
    tableColumns,
    perPage,
    currentPage,
    totalData,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,

    resolveStatusVariant,
    showStatus,
    refetchData,

    // Extra Filters
    statusFilter,
  }
}
